'use client';

import { useSearchParams } from 'next/navigation';
import { useCallback, useRef } from 'react';

import { QUERY_TOKEN_PARAM_NAME } from '~constants/token';
import { QUERY_PROMOCODE_PARAM_NAME } from '~features/promocode';
import { useRouter } from '~i18n/navigation';

function clearParams(params: URLSearchParams): URLSearchParams {
	const newParams = new URLSearchParams(params);
	newParams.delete(QUERY_TOKEN_PARAM_NAME);
	newParams.delete(QUERY_PROMOCODE_PARAM_NAME);
	newParams.delete('botId');
	newParams.delete('originLocale');
	return newParams;
}

export const useClearParamsPerformer = () => {
	const doneRef = useRef(false);
	const { replace } = useRouter();
	const searchParams = useSearchParams();

	return useCallback(() => {
		if (doneRef.current) {
			return;
		}

		doneRef.current = true;

		const newSearchParams = clearParams(searchParams);

		// Calling "replace" with the same url causes full page remount
		if (searchParams.toString() !== newSearchParams.toString()) {
			void replace(`?${newSearchParams}`);
		}

		return true;
	}, [replace, searchParams]);
};
